export const contactTypeKeys = {
    lead: 'lead',
    customer: 'customer',
    churn: 'churn',
}

export const isDiscardableContact = ({ contactType, customerId, leadId } = {}) =>
    !customerId && (contactType === contactTypeKeys.lead || !!leadId);
